document.documentElement.classList.remove('no-js');

const qs = (selector, scope = document) => (scope ? scope.querySelector(selector) : null);
const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
const money = (cents) => (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

/* ---------------------------------------------------------------- carrinho */

let lastCartOpener = null;

function openCart(opener) {
  const drawer = qs('[data-cart-drawer]');
  if (!drawer) return;
  lastCartOpener = opener || null;
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  qs('[data-cart-overlay]')?.classList.add('open');
  document.body.classList.add('no-scroll');
  qs('[data-cart-close]', drawer)?.focus();
}

function closeCart() {
  const drawer = qs('[data-cart-drawer]');
  if (!drawer) return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  qs('[data-cart-overlay]')?.classList.remove('open');
  document.body.classList.remove('no-scroll');
  lastCartOpener?.focus();
  lastCartOpener = null;
}

async function fetchCart() {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  return response.json();
}

function cartThumb(item) {
  // a foto do produto sempre vence a marcação, igual ao snippet do Liquid
  if (item.image) {
    const src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
    return `<img class="img-slot__img is-contain" src="${src}" alt="" loading="lazy" width="56" height="100">`;
  }
  return `<span class="img-slot img-slot--empty img-slot--xs mini-sachet" role="img" aria-label="Espaço reservado para imagem do produto">
      <span class="img-slot__frame" aria-hidden="true"><span class="img-slot__tag">imagem</span><span class="img-slot__dims">56×100</span></span>
    </span>`;
}

function renderCart(cart) {
  qsa('[data-cart-count]').forEach((el) => {
    el.textContent = cart.item_count;
    el.classList.toggle('is-empty', cart.item_count === 0);
  });

  const empty = cart.item_count === 0;
  qs('[data-cart-empty]')?.toggleAttribute('hidden', !empty);
  qs('[data-cart-filled]')?.toggleAttribute('hidden', empty);

  const items = qs('[data-cart-items]');
  if (items) {
    items.innerHTML = cart.items
      .map((item) => {
        // a caixa em quantidade: "2 caixas • 60 doses", com o preço cheio
        // riscado quando o desconto automático do kit já entrou na linha
        const kit = ehKit(item);
        const detalhe = kit ? `${caixasTexto(item.quantity)} • ${item.quantity * 30} doses` : item.variant_title;
        const comDesconto = item.original_line_price > item.final_line_price;
        return `
      <div class="cart-product" data-cart-item-key="${item.key}">
        <div class="cart-thumb">${cartThumb(item)}</div>
        <div>
          <h4>${item.product_title}</h4>
          ${detalhe ? `<p>${detalhe}</p>` : ''}
          <strong class="cart-line-price">${comDesconto ? `<s>${money(item.original_line_price)}</s> ` : ''}${money(item.final_line_price)}</strong>
          <div class="cart-links"><a href="${item.url}">${kit ? 'Alterar quantidade' : 'Alterar opção'}</a><a href="/cart/change?id=${item.key}&quantity=0">Remover</a></div>
        </div>
      </div>
    `;
      })
      .join('');
  }

  // subtotal é o preço cheio; o desconto do kit aparece como linha própria
  // e o total é o que a Shopify vai cobrar
  qsa('[data-cart-subtotal]').forEach((el) => {
    el.textContent = money(cart.original_total_price);
  });
  qsa('[data-cart-total]').forEach((el) => {
    el.textContent = money(cart.total_price);
  });
  const desconto = cart.original_total_price - cart.total_price;
  qsa('[data-cart-discount-row]').forEach((row) => {
    row.hidden = desconto <= 0;
  });
  qsa('[data-cart-discount]').forEach((el) => {
    el.textContent = `− ${money(desconto)}`;
  });

  const caixas = cart.items.reduce((total, item) => {
    const multiplicador = {
      'cafe-com-creatina-coffeetine': 1,
      'coffeetine-2-caixas': 2,
      'coffeetine-3-caixas': 3
    }[item.handle] || 0;
    return total + item.quantity * multiplicador;
  }, 0);
  qsa('[data-ship-bar]').forEach((bar) => {
    const text = qs('[data-ship-text]', bar);
    if (text) {
      text.textContent = caixas >= 2
        ? 'Frete grátis liberado.'
        : caixas === 1
          ? 'Adicione mais 1 caixa para ganhar frete grátis.'
          : 'Frete grátis a partir da 2ª caixa.';
    }
    const fill = qs('[data-ship-fill]', bar);
    if (fill) fill.style.width = `${Math.min(100, caixas * 50)}%`;
    bar.classList.toggle('is-free', caixas >= 2);
    qsa('[data-cart-shipping]').forEach((el) => {
      el.textContent = caixas >= 2 ? 'Grátis' : 'Calculado no checkout';
    });
  });

  // o pixel lê daqui no clique de finalizar: navegar não dá tempo de buscar
  qsa('[data-checkout]').forEach((el) => el.setAttribute('data-cart-cents', cart.total_price));

}

/* ------------------------------------------------------------ seletor kits */

function updateRoutine(card) {
  const group = card.closest('[data-routine-group]');
  if (!group) return;

  qsa('[data-routine-card]', group).forEach((item) => {
    const isCurrent = item === card;
    item.classList.toggle('active', isCurrent);
    // marcar direto: disparar .click() no rádio faria o evento voltar ao
    // document e chamar esta função de novo, em laço.
    const radio = qs('input[type="radio"]', item);
    if (radio) radio.checked = isCurrent;
  });

  const scope = group.closest('form, .routine-wrap, .pdp-buybox') || document;

  const variantInput = scope.querySelector('[data-selected-variant]');
  if (variantInput && card.dataset.variantId) variantInput.value = card.dataset.variantId;

  // os cartões são a mesma caixa em quantidade 1, 2 ou 3
  const quantityInput = scope.querySelector('[data-selected-quantity]');
  if (quantityInput && card.dataset.quantity) quantityInput.value = card.dataset.quantity;

  const selected = scope.querySelector('[data-routine-selected]');
  if (selected && card.dataset.title) selected.textContent = `Selecionado: ${card.dataset.title}`;

  const price = scope.querySelector('[data-product-price]');
  if (price && card.dataset.price) price.textContent = card.dataset.price;

  const installment = scope.querySelector('[data-product-installment]');
  if (installment && card.dataset.installment) installment.textContent = card.dataset.installment;

  const buy = scope.querySelector('[data-product-buy]');
  if (buy && card.dataset.price) buy.textContent = `COMPRAR AGORA • ${card.dataset.price}`;

  // na home o botão não adiciona ao carrinho: leva à página do kit escolhido,
  // que já abre com esse kit selecionado.
  const irParaKit = scope.querySelector('[data-go-to-kit]');
  if (irParaKit && card.dataset.url) irParaKit.setAttribute('href', card.dataset.url);

  syncStickyBar(card);
}

/* ------------------------------------------------------ barra fixa mobile */

function syncStickyBar(card) {
  // a barra só tem botão; na home ele leva ao kit escolhido
  const bar = qs('[data-sticky-buy]');
  if (!bar || !card) return;
  const ir = qs('[data-sticky-go]', bar);
  if (ir && card.dataset.url) ir.setAttribute('href', card.dataset.url);
  const add = qs('[data-sticky-add]', bar);
  if (add && card.dataset.variantId) {
    add.dataset.variantId = card.dataset.variantId;
    add.dataset.quantity = card.dataset.quantity || '1';
  }
}

function ligarVideosNaTela() {
  const videos = qsa('.video-card__frame video, .prep-media video');
  if (!videos.length) return;
  if (!('IntersectionObserver' in window)) {
    videos.forEach((v) => v.play?.().catch(() => {}));
    return;
  }
  const observador = new IntersectionObserver(
    (entradas) => {
      entradas.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          target.preload = 'auto';
          target.play?.().catch(() => {});
        } else {
          target.pause?.();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );
  videos.forEach((v) => {
    v.muted = true;
    v.setAttribute('playsinline', '');
    observador.observe(v);
  });
}

/* ------------------------------------------------- avaliações: carrossel */

function ligarAvaliacoes() {
  qsa('[data-avaliacoes]').forEach((viewport) => {
    const grupo = qs('.avaliacoes__group', viewport);
    if (!grupo) return;

    const larguraGrupo = () => grupo.getBoundingClientRect().width;

    // loop sem emenda: o conteúdo existe em duas cópias; ao cruzar a
    // fronteira de uma, a rolagem volta o equivalente — em ambas as direções.
    viewport.addEventListener(
      'scroll',
      () => {
        const w = larguraGrupo();
        if (w <= 0) return;
        if (viewport.scrollLeft >= w) viewport.scrollLeft -= w;
        else if (viewport.scrollLeft <= 0) viewport.scrollLeft += w;
      },
      { passive: true }
    );
    viewport.scrollLeft = 1;

    // arrastar com o mouse; no toque o navegador já rola nativamente
    let arrastando = false;
    let moveu = false;
    let x0 = 0;
    let s0 = 0;
    viewport.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      arrastando = true;
      moveu = false;
      x0 = e.clientX;
      s0 = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', (e) => {
      if (!arrastando) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 4) moveu = true;
      viewport.scrollLeft = s0 - dx;
    });
    window.addEventListener('pointerup', () => {
      arrastando = false;
      viewport.classList.remove('is-dragging');
    });
    // um arrasto não pode disparar o clique no botão de som
    viewport.addEventListener(
      'click',
      (e) => {
        if (moveu) {
          e.preventDefault();
          e.stopPropagation();
          moveu = false;
        }
      },
      true
    );

    // passeio automático, devagar; qualquer interação pausa e depois retoma
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const duracao = Number(viewport.dataset.speed || 45) * 1000;
    let pausadoAte = 0;
    ['pointerdown', 'wheel', 'touchstart'].forEach((evento) =>
      viewport.addEventListener(evento, () => (pausadoAte = performance.now() + 4000), { passive: true })
    );
    let ultimo = performance.now();
    let acumulado = 0;
    function passo(agora) {
      const dt = agora - ultimo;
      ultimo = agora;
      if (agora > pausadoAte && !arrastando && dt < 100) {
        // acumula frações de pixel: scrollLeft só aceita inteiros
        acumulado += (larguraGrupo() / duracao) * dt;
        if (acumulado >= 1) {
          const inteiro = Math.floor(acumulado);
          viewport.scrollLeft += inteiro;
          acumulado -= inteiro;
        }
      }
      requestAnimationFrame(passo);
    }
    requestAnimationFrame(passo);
  });
}

function watchStickyBar() {
  const bar = qs('[data-sticky-buy]');
  if (!bar) return;

  // O botão de verdade da página. Enquanto ele estiver na tela a barra some:
  // duas chamadas para a mesma ação, ao mesmo tempo, só atrapalham.
  const ctas = qsa('.pdp-buybox .product-buy, .hero-actions .btn-primary, .routine-actions .btn-primary, .page-cta .btn');
  const rodape = qs('.footer');
  bar.hidden = false;

  const naTela = new Set();
  if (ctas.length && 'IntersectionObserver' in window) {
    const observador = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((e) => (e.isIntersecting ? naTela.add(e.target) : naTela.delete(e.target)));
        avaliar();
      },
      { rootMargin: '-40px 0px -120px 0px' }
    );
    ctas.forEach((cta) => observador.observe(cta));
  }

  // Onde existe hero, a barra só entra depois que ela sai da tela: mostrar o
  // preço no meio da hero anularia a decisão de construir valor antes do preço.
  const hero = qs('.hero');

  function avaliar() {
    const rolou = hero
      ? hero.getBoundingClientRect().bottom < 0
      : window.scrollY > 320;
    const noRodape = rodape ? rodape.getBoundingClientRect().top < window.innerHeight - 40 : false;
    bar.classList.toggle('is-visible', rolou && naTela.size === 0 && !noRodape);
  }

  avaliar();
  window.addEventListener('scroll', avaliar, { passive: true });
  window.addEventListener('resize', avaliar, { passive: true });
}

/* ------------------------------------------------------------- um kit só */

// A caixa é um produto só, e o kit é a mesma caixa em quantidade 2 ou 3 —
// o preço de kit vem de um desconto automático da Shopify por quantidade.
// Escolher um kit DEFINE a quantidade da caixa no carrinho (não soma com o
// que já estava), então ninguém acaba com 1 + 2 sem querer. Os handles dos
// kits antigos ficam na lista para tirar do carrinho qualquer linha deles
// que tenha sobrado de antes da mudança.
const KIT_HANDLES = ['cafe-com-creatina-coffeetine', 'coffeetine-2-caixas', 'coffeetine-3-caixas'];
const ehKit = (item) => KIT_HANDLES.includes(item.handle);
const caixasTexto = (n) => (n === 1 ? '1 caixa' : `${n} caixas`);

function avisarTroca(texto) {
  const aviso = qs('[data-cart-note]');
  if (!aviso) return;
  aviso.textContent = texto || '';
  aviso.hidden = !texto;
}

async function addVariant(variantId, button, quantity) {
  const qtd = Math.max(1, Number(quantity) || 1);
  if (!variantId) {
    const selected = button?.closest('.routine-wrap, form')?.querySelector('[data-routine-card].active');
    window.location.href = selected?.dataset.url || '/products/cafe-com-creatina-coffeetine';
    return;
  }

  const original = button?.textContent;
  if (button) {
    button.disabled = true;
    button.dataset.loading = 'true';
    button.textContent = 'ADICIONANDO...';
  }

  try {
    const id = Number(variantId);
    const atual = await fetchCart();

    // Um único /cart/update.js: a caixa fica na quantidade escolhida (mesmo
    // que já estivesse lá com outra) e qualquer kit antigo sai. A amostra e
    // qualquer outro item não entram na conta.
    const updates = {};
    const removidos = [];
    let anterior = 0;
    atual.items.forEach((item) => {
      if (!ehKit(item)) return;
      if (item.variant_id === id) {
        anterior = item.quantity;
        updates[item.key] = qtd;
      } else {
        updates[item.key] = 0;
        removidos.push(item.product_title);
      }
    });
    if (!anterior) updates[id] = qtd;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!response.ok) throw new Error('Cart update failed');
    const cart = await response.json();

    const adicionado = cart.items.find((item) => item.variant_id === id);
    if (adicionado && qtd > anterior) {
      document.dispatchEvent(new CustomEvent('coffeetine:item-adicionado', { detail: adicionado }));
    }

    renderCart(cart);
    let aviso = '';
    if (adicionado && removidos.length) {
      aviso = `Trocamos para ${caixasTexto(qtd)}. O carrinho leva um kit por vez, sempre com o melhor preço.`;
    } else if (adicionado && anterior && anterior !== qtd) {
      aviso = `Seu carrinho agora leva ${caixasTexto(qtd)}.`;
    }
    avisarTroca(aviso);
    if (button) button.textContent = original;
    openCart(button);
  } catch (error) {
    console.error(error);
    if (button) button.textContent = 'TENTE NOVAMENTE';
  } finally {
    if (button) {
      button.disabled = false;
      delete button.dataset.loading;
    }
  }
}

/* -------------------------------------------------------------- interações */

function abrirMenu(botao) {
  const painel = qs('[data-mobile-panel]');
  if (!painel) return;
  painel.classList.add('open');
  painel.setAttribute('aria-hidden', 'false');
  qs('[data-menu-overlay]')?.classList.add('open');
  document.body.classList.add('no-scroll');
  botao?.setAttribute('aria-expanded', 'true');
  qs('[data-menu-close]', painel)?.focus();
}

function fecharMenu() {
  const painel = qs('[data-mobile-panel].open');
  if (!painel) return;
  painel.classList.remove('open');
  painel.setAttribute('aria-hidden', 'true');
  qs('[data-menu-overlay]')?.classList.remove('open');
  document.body.classList.remove('no-scroll');
  qs('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
}

function toggleAccordion(item, button) {
  const open = item.classList.toggle('open');
  button?.setAttribute('aria-expanded', open ? 'true' : 'false');
}

document.addEventListener('click', async (event) => {
  const menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    const painel = qs('[data-mobile-panel]');
    painel?.classList.contains('open') ? fecharMenu() : abrirMenu(menuToggle);
  }
  if (event.target.closest('[data-menu-close], [data-menu-overlay]')) fecharMenu();
  // link do menu leva embora: fecha antes de navegar
  if (event.target.closest('.nav-drawer__links a')) fecharMenu();

  // o carrinho é sempre a gaveta, nunca a página /cart
  const linkCarrinho = event.target.closest('a[href$="/cart"], a[href*="/cart?"]');
  const opener = event.target.closest('[data-cart-open]');
  if (linkCarrinho || opener) {
    event.preventDefault();
    fecharMenu();
    openCart(opener || linkCarrinho);
  }
  if (event.target.closest('[data-cart-close]') || event.target.closest('[data-cart-overlay]')) closeCart();

  // "Remover" na gaveta: tira a linha sem sair da página (o link /cart/change
  // fica como fallback sem JavaScript, e ele cai no redirecionamento do /cart)
  const remover = event.target.closest('[data-cart-drawer] a[href^="/cart/change"]');
  if (remover) {
    event.preventDefault();
    const key = new URL(remover.href, window.location.origin).searchParams.get('id');
    if (!key) return;
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!response.ok) throw new Error('Cart change failed');
      avisarTroca('');
      renderCart(await response.json());
    } catch (error) {
      console.error(error);
      window.location.href = remover.href;
    }
  }

  const routineCard = event.target.closest('[data-routine-card]');
  if (routineCard) updateRoutine(routineCard);

  const addSelected = event.target.closest('[data-add-selected]');
  if (addSelected) {
    const selected = addSelected.closest('.routine-wrap')?.querySelector('[data-routine-card].active');
    await addVariant(selected?.dataset.variantId, addSelected, selected?.dataset.quantity);
  }

  const stickyAdd = event.target.closest('[data-sticky-add]');
  if (stickyAdd) await addVariant(stickyAdd.dataset.variantId, stickyAdd, stickyAdd.dataset.quantity);

  const som = event.target.closest('[data-video-sound]');
  if (som) {
    const video = qs('video', som.closest('.video-card__frame, .prep-media'));
    if (video) {
      video.muted = !video.muted;
      qs('[data-sound-off]', som).hidden = !video.muted;
      qs('[data-sound-on]', som).hidden = video.muted;
      if (!video.muted) {
        qsa('.video-card__frame video, .prep-media video').forEach((outro) => {
          if (outro !== video) outro.muted = true;
        });
      }
    }
  }

  const faq = event.target.closest('.faq-q');
  if (faq) toggleAccordion(faq.parentElement, faq);

  const accordion = event.target.closest('.acc button');
  if (accordion) toggleAccordion(accordion.parentElement, accordion);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  closeCart();
  fecharMenu();
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[data-product-buy]');
  await addVariant(
    form.querySelector('[data-selected-variant]')?.value,
    button,
    form.querySelector('[data-selected-quantity]')?.value
  );
});

// Newsletter do rodapé: o e-mail vai direto para a lista do Klaviyo pela API
// pública dele, sem recarregar a página. Sem as duas chaves no personalizador
// o form segue o caminho nativo da Shopify (form 'customer'), e o Klaviyo
// recebe pela integração. Resposta 202 sem corpo é o sucesso.
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-newsletter]');
  if (!form) return;
  const company = form.dataset.company?.trim();
  const list = form.dataset.list?.trim();
  if (!company || !list) return;
  event.preventDefault();

  const input = form.querySelector('input[type="email"]');
  const button = form.querySelector('button[type="submit"]');
  const msg = form.querySelector('[data-newsletter-msg]');
  const email = input?.value.trim();
  const dizer = (texto, classe) => {
    if (!msg) return;
    msg.textContent = texto;
    msg.classList.remove('is-ok', 'is-error');
    if (classe) msg.classList.add(classe);
  };
  if (!email || !input.checkValidity()) {
    dizer(form.dataset.error, 'is-error');
    input?.focus();
    return;
  }

  button.disabled = true;
  try {
    const resposta = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(company)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.source || 'Rodapé do site',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: list } } },
        },
      }),
    });
    if (!resposta.ok) throw new Error(`klaviyo ${resposta.status}`);
    dizer(form.dataset.success, 'is-ok');
    input.value = '';
  } catch (erro) {
    console.error(erro);
    dizer(form.dataset.error, 'is-error');
  } finally {
    button.disabled = false;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // ?caixas=2 na URL (a home manda para cá, e os links antigos dos kits
  // redirecionam com ele) marca o cartão daquela quantidade ao abrir.
  const caixas = new URLSearchParams(window.location.search).get('caixas');
  const caixasValido = caixas && /^[1-9]$/.test(caixas) ? caixas : null;
  qsa('[data-routine-group]').forEach((group) => {
    const pedido = caixasValido ? qs(`[data-routine-card][data-quantity="${caixasValido}"]`, group) : null;
    const card = pedido || qs('[data-routine-card].active', group) || qs('[data-routine-card]', group);
    if (card) updateRoutine(card);
  });

  watchStickyBar();
  ligarVideosNaTela();
  ligarAvaliacoes();

  // O carrinho da loja é a gaveta. A página /cart redireciona para cá com
  // #carrinho na URL (zero-cart.liquid); a âncora abre a gaveta e some.
  if (window.location.hash === '#carrinho') {
    openCart();
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  qsa('.faq-q, .acc button').forEach((button) => {
    button.setAttribute('aria-expanded', button.parentElement.classList.contains('open') ? 'true' : 'false');
  });
});
